export const calculateOpacity = (eventDate) => {
    const ageInYears = (new Date() - new Date(eventDate)) / (1000 * 60 * 60 * 24 * 365);
    if (ageInYears <= 2) return 1; // 100% opacity for events 2 years or newer
    if (ageInYears >= 10) return 0.4; // 40% opacity for events 10 years or older
    // Linear interpolation for events between 2 and 10 years old
    return 1 - (0.6 * (ageInYears - 2) / 8);
  };